import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../home.css";
import Loader from "../../../Elements/Loader/Loader";
import RestaurantGrid from "../../../Sections/RestaurantHome/RestaurantGrid/RestaurantGrid";
import { fetchRestaurantsByCategory } from "../../../../Services/fetchRestaurantsByCategory";
import useGeolocation from "../../../../Hooks/useGeolocation";
import {
  RADIUS_KM,
  isValidCoord,
  annotateWithDistance,
  filterByRadius,
} from "../../../../Utilities/geocode";

const RestaurantsByCategory = () => {
  const { categoriaPrincipal } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { status: geoStatus, coords } = useGeolocation();

  // Leer usuario de LS
  useEffect(() => {
    const data = localStorage.getItem("logindata");
    if (data) {
      try { setUser(JSON.parse(data)); } catch { /* noop */ }
    }
  }, []);

  // Cargar restaurantes por categoría cuando tengamos ubicación
  useEffect(() => {
    if (!categoriaPrincipal) return;
    if (geoStatus !== "granted" || !coords) return;

    (async () => {
      try {
        setLoading(true);
        setError("");
        const items = await fetchRestaurantsByCategory(categoriaPrincipal);

        const valid = (items || []).filter((r) => isValidCoord(r.lat, r.lng));
        const withDist = annotateWithDistance(coords, valid);
        const inRadius = filterByRadius(withDist, RADIUS_KM);

        // Opcional: ordenar por distancia ascendente
        inRadius.sort((a, b) => (a.distanceKm || 0) - (b.distanceKm || 0));

        setRestaurants(inRadius);
      } catch (err) {
        setError(err?.message || "No se pudieron cargar los Comercios");
      } finally {
        setLoading(false);
      }
    })();
  }, [categoriaPrincipal, geoStatus, coords]);

  const goToDetail = (id) => id && navigate(`/restaurants/${id}`);

  if (geoStatus !== "granted") return null;

  return (
    <section className="home-page">
      <div className="container-fluid container-mh py-3 py-md-4">
        <div className="row align-items-start g-3">
          <div className="col-12">
            <div className="home-intro">
              {user ? (
                <h2 className="home-h2">
                  {categoriaPrincipal} 🍴
                </h2>
              ) : (
                <h2 className="home-h2">No has iniciado sesión</h2>
              )}
              <p className="muted">
                Comercios cercanos (≤ {RADIUS_KM} km) en la categoría{" "}
                <strong>{categoriaPrincipal}</strong>.
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-3 mt-md-4">
          <div className="col-12">
            {loading && <Loader />}
            {error && <p className="error">{error}</p>}

            {!loading && !error && restaurants.length === 0 && (
              <p className="muted">
                No hay Comercios en un radio de {RADIUS_KM} km para la categoría{" "}
                <strong>{categoriaPrincipal}</strong>.
              </p>
            )}

            <RestaurantGrid items={restaurants} onOpenDetail={goToDetail} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RestaurantsByCategory;